import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Button from "src/components/ui/Button";
import { SITE_SETTINGS } from "src/constants/common";

const Navbar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const links = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/pricing", label: "Pricing" },
    { path: "/faqs", label: "FAQs" },
    { path: "/contact", label: "Contact" },
  ];

  return (
    <header className="sticky top-0 bg-white shadow z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" className="text-2xl font-bold text-indigo-600">
          {SITE_SETTINGS.NAME}
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8 text-gray-700 font-medium">
          {links.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              className={`hover:text-indigo-600 transition text-sm ${
                location.pathname === l.path ? "text-indigo-600" : ""
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Button variant="ghost" onClick={() => navigate("/app/login")}>
            Login
          </Button>
          <Button onClick={() => navigate("/pricing")}>Get Started</Button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden text-gray-700 focus:outline-none"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden bg-white border-t">
          {links.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              onClick={() => setOpen(false)}
              className={`block px-6 py-3 text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 ${
                location.pathname === l.path
                  ? "bg-indigo-50 text-indigo-600"
                  : ""
              }`}
            >
              {l.label}
            </Link>
          ))}
          <div className="flex items-center gap-4 px-6 py-3">
            <Button
              variant="ghost"
              onClick={() => navigate("/app/login")}
              fullWidth
            >
              Login
            </Button>
            <Button onClick={() => navigate("/pricing")} fullWidth>
              Get Started
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
